import { render } from "./IndustryPage.vue?vue&type=template&id=61c28ad2"
import script from "./IndustryPage.vue?vue&type=script&lang=js"
export * from "./IndustryPage.vue?vue&type=script&lang=js"

import "./IndustryPage.vue?vue&type=style&index=0&id=61c28ad2&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__